module.exports = __webpack_public_path__ + "img/color-g-2@2x.dec697c.webp";